import { postForm, putForm } from '../helpers/axios';

export function create(siteTemplateFormData) {
  return postForm(`/site_templates`, siteTemplateFormData);
}

export function update(id, siteTemplateFormData) {
  return putForm(`/site_templates/${id}`, siteTemplateFormData);
}
